import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Card, Row, Col, Popover} from 'antd';
import ReactECharts from 'echarts-for-react';
import { QuestionCircleOutlined,DownloadOutlined } from '@ant-design/icons';
import help from '../../config/help.json';
import { CSVLink } from 'react-csv';


import './analytics.css';


var cc_data;

class ActiveUsersByPlatformCard extends Component {
	constructor(props) {
		super(props);
		this.state = {
		 }
	}

	async componentDidUpdate(prevProps) {
	}


	render() {
		const { loading, userTheme,opensearchActiveUserByPlatformList } = this.props;

		cc_data = opensearchActiveUserByPlatformList || [];

		const option = {
				tooltip: {
					trigger: 'item'
				},
				legend: {
					type: 'scroll',
					top: '5%',
					left: 'center'
				},
				series: [
					{
					name: 'Total Active Users',
					type: 'pie',
					radius: ['40%', '70%'],
					avoidLabelOverlap: false,
					itemStyle: {
						borderRadius: 10,
						borderColor: '#fff',
						borderWidth: 2
					},
					label: {
						show: false,
						position: 'center'
					},
					emphasis: {
						label: {
						show: true,
						fontSize: 40,
						fontWeight: 'bold'
						}
					},
					labelLine: {
						show: false
					},
					data: cc_data.map((d)=> ({name:d.key, value: d.userid.value}))
					}
				]
				};

		return (
      <Card className="analyticCard analyticActiveUsersCard">
				<h3 className="title">{`Total Active Users  `}
				<Popover placement="topLeft"
						overlayStyle={{width:'300px'}}
						content= {help.find(d=> d.name ==='ActiveUsersByPlatformCard').en}
						trigger="click"><QuestionCircleOutlined />
					</Popover>
					<CSVLink data={cc_data.map(c => ({ platforms: c.key, count: c.userid.value }))} target="_blank" filename={"Total Active Users.csv"}>
						<DownloadOutlined />
					</CSVLink>
				</h3>
				<Row>
				 <Col span={24}>
				 	<ReactECharts style={{ height: 320, width: '100%' }} theme={userTheme} option={option} notMerge={true} showLoading={loading} loadingOption={{color:"#74add1"}} />
				</Col>
 				</Row>
     </Card>
		);
	}


}

const mapStateToProps = state => ({
	router: state.router,
	userTheme: state.user.userTheme,
	selectedOrganization: state.user.selectedOrganization,
	opensearchActiveUserByPlatformList: state.analytics.opensearchActiveUserByPlatformList
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
		},
		dispatch
	);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ActiveUsersByPlatformCard));
